

app.controller('RegisterCtrl', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter, $translate) {
    $scope.user = {
        AccountType: 1,
        Email: '',
        Password: '',
        Handphone: '',
        Sales: '',
        RegistrationInfo: '',
        RegistrationInfoSosmed: '',
        RegistrationInfoOthers: ''
    };

    $scope.showRegisSales = false;
    $scope.showRegisNonSales = true;
    $scope.disableSales = false;

    

    $scope.user.PhoneCode = '+62-';
    $scope.ConfirmPassword = '';
    $scope.disclaimerRek = false;
    $scope.SalesSelected = '';
    $scope.ListSales = [];
    $scope.ListSalesDefault = [];
    $scope.ListSalesAll = [];

    $scope.page = 'registration';

    $scope.selectSales = function (item, model, label, event) {
        if (item.SalesPersonNID) {
            $scope.user.Sales = item.SalesPersonNID;
            $scope.SalesSelected = item;
        }

    };

    $scope.salesChange = function () {
        //console.log('sales2', $scope.user.Sales);
    }

    var allPromise = $q.all([
         $http({
             method: 'GET',
             url: '/service/client.svc/GetCountryPhone',
             cache: true,
         }).then(function (data) {
             $scope.ListCountryPhone = data.data.d;
         }, function (error) { }),

         $http({
             method: 'GET',
             url: '/service/client.svc/GetCIFSalesDefault',
             cache: true,
         }).then(function (data) {
             $scope.ListSalesDefault = data.data.d;
             console.log('listSalesDefault', data);

             if ($scope.ListSalesDefault != null)
             {
                 $scope.ListSales = $scope.ListSalesDefault;
                 $scope.user.Sales = $scope.ListSales[0];
             }
             
         }, function (error) { }),

         $http({
             method: 'GET',
             url: '/service/client.svc/GetCIFSalesAll',
             cache: true,
         }).then(function (data) {
             $scope.ListSalesAll = data.data.d;
             console.log('ListSalesAll', $scope.ListSalesAll);

         }, function (error) { }),
    ]);

    $scope.prepareData = function () {

        //if ($scope.user.AccountType)
        //    $scope.user.AccountType = Number($scope.user.AccountType);

        //if ($scope.user.RegistrationInfo)
        //    $scope.user.RegistrationInfo = Number($scope.user.RegistrationInfo);

        //if ($scope.user.RegistrationInfoSosmed)
        //    $scope.user.RegistrationInfoSosmed = Number($scope.user.RegistrationInfoSosmed);
        //else
        //    $scope.user.RegistrationInfoSosmed = 0;

        if ($scope.user.Sales)
            $scope.user.Sales = $scope.user.Sales.SalesPersonID;
        else
            $scope.user.Sales = 'SALES21';

        console.log('sales', $scope.user.Sales);

    };

    $scope.submit = function () {
        $scope.prepareData();
        //var challenge = grecaptcha.getResponse();
        //if (!challenge) {
        //    alert("Mohon ulangi centang captcha");
        //    return false;
        //}
        //else {
        //    $scope.user.challenge = challenge;
        //}
        $translate('VALIDATE.confirmation').then(function (strText) {
            $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/RegistrasiUser',
                        data: {
                            User: $scope.user
                        }
                    }).then(function (data) {
                        console.log('res', data);

                        if (data.data.d.result) {
                            swal('Terima kasih telah melakukan registrasi Opening Account Online di PT. Erdikha Elit Sekuritas.', data.data.d.message, 'success').then(function () {
                                $window.location.href = "#/login";
                                $window.location.reload();
                            });
                        }
                        else {
                            swal('Failed', data.data.d.message, 'info');
                        }
                    }, function (error) { });
                }
            });
        });
    };


    allPromise.then(function () {
        if ($routeParams.id) {
            //console.log('param', $routeParams.id);

            var sales = $filter('filter')($scope.ListSalesAll, { SalesPersonID: $routeParams.id }, true)[0];
            console.log('sales', sales);

            $scope.ListSales = $scope.ListSalesAll;
            $scope.user.Sales = sales;
            $scope.user.RegistrationInfo = '1';
            $scope.showRegisSales = true;
            $scope.showRegisNonSales = false;
            $scope.disableSales = true;
        }
        else {
            $scope.user.Sales = $scope.ListSales[0];
            $scope.showRegisSales = false;
            $scope.showRegisNonSales = true;
            $scope.disableSales = false;
        }

        console.log('SALESXXX', $scope.user.Sales);
    });


});



















app.controller('ActivationCtrl', function ($scope, $routeParams, $rootScope, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $translate) {
    $scope.user = {
        Email: '',
        OTP: '',
    };

    $scope.printXyz = function () {
        console.log($scope.user);
        console.log('CODE', $scope.user.code1);
        console.log('EMAIL', $scope.user.Email);
    }

    if ($routeParams.generatedkey) {
        $scope.user.generatedkey = $routeParams.generatedkey;
    }
    else {
        $window.location.href = "#/register";
        $window.location.reload();
    }

    $scope.page = 'activation';

    var allPromise = $q.all([

    ]);


    $scope.submit = function () {
        $scope.user.OTP = $scope.user.code1 + $scope.user.code2 + $scope.user.code3 + $scope.user.code4;
        console.log('user', $scope.user);
        $translate('VALIDATE.confirmation').then(function (strText) {
            $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/AktivasiUser',
                        data: {
                            User: $scope.user
                        }
                    }).then(function (data) {

                        if (data.data.d.result) {
                            swal('Activation Success', data.data.d.message, 'success').then(function () {
                                $window.location.href = "#/login";
                                $window.location.reload();
                            });
                        }
                        else {
                            swal('Failed, Check OTP in Email', data.data.d.message, 'info');
                        }
                    }, function (error) { });
                }
            });
        });
    }


    allPromise.then(function () {

    });


    $scope.verif = function (index, event) {
        if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4)
            console.log('done1')
        else {
            if (index && ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
                let focusCtrl = "#verif" + (index + 1);
                angular.element(focusCtrl).focus();
            }
        }
    }

    $scope.processCb = function (event) {
        let data = event.originalEvent.clipboardData.getData('text/plain');
        if (data.length == 4) {
            $scope.code1 = data[0];
            $scope.code2 = data[1];
            $scope.code3 = data[2];
            $scope.code4 = data[3];
        }
    }

    $scope.verFocus = function (index) {
        if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4)
            console.log('done2')
        else {
            switch (index) {
                case 1: $scope.code1 = ''; break;
                case 2: $scope.code2 = ''; break;
                case 3: $scope.code3 = ''; break;
                case 4: $scope.code4 = ''; break;
            }
        }
    }
});
